exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/library/modules/_wks-ext.js
// module id = 4U+g
// module chunks = 5